import { ChevronLeft, ChevronRight } from 'lucide-react';
import type { EventsDirectionIconProps } from 'Modules/softphone/components/SoftphoneDevTools/DevToolsTabs/EventsTab/EventsDirectionIcon/index.types';
import {
  DIRECTION,
} from 'Modules/softphone/components/SoftphoneDevTools/styles';
import React from 'react';
import { cn } from '~/lib/utils';

/**
 * EventsDirectionIcon - Whether an event was received or sent
 *
 * A chevron, for the same reason as the direction badge: an arrow at this
 * size is wide and short, and in a column of rows the eye reads the vertical
 * stroke.
 */
export const EventsDirectionIcon: React.FC<EventsDirectionIconProps> = ({
  direction,
}) => {
  const isIncoming = direction === 'incoming';
  const Chevron = isIncoming ? ChevronLeft : ChevronRight;

  return (
    <Chevron
      className={cn(
        'h-3.5 w-3.5 flex-shrink-0',
        isIncoming ? DIRECTION.inbound.ink : DIRECTION.outbound.ink
      )}
      strokeWidth={3}
      aria-label={isIncoming ? 'incoming' : 'outgoing'}
    />
  );
};
